/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "fac",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "amount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "factory",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
        ],
        name: "pool",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
            {
                internalType: "uint128",
                name: "amount",
                type: "uint128",
            },
            {
                internalType: "int24",
                name: "lowPt",
                type: "int24",
            },
        ],
        name: "swapX2Y",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "int24",
                name: "",
                type: "int24",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "x",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "y",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "swapX2YCallback",
        outputs: [],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
            {
                internalType: "uint128",
                name: "desireY",
                type: "uint128",
            },
            {
                internalType: "int24",
                name: "highPt",
                type: "int24",
            },
        ],
        name: "swapX2YDesireY",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "int24",
                name: "",
                type: "int24",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
            {
                internalType: "uint128",
                name: "amount",
                type: "uint128",
            },
            {
                internalType: "int24",
                name: "highPt",
                type: "int24",
            },
        ],
        name: "swapY2X",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "int24",
                name: "",
                type: "int24",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "x",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "y",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "swapY2XCallback",
        outputs: [],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
            {
                internalType: "uint128",
                name: "desireX",
                type: "uint128",
            },
            {
                internalType: "int24",
                name: "highPt",
                type: "int24",
            },
        ],
        name: "swapY2XDesireX",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "int24",
                name: "",
                type: "int24",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class TestQuoter__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(fac, overrides) {
        return super.deploy(fac, overrides || {});
    }
    getDeployTransaction(fac, overrides) {
        return super.getDeployTransaction(fac, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
TestQuoter__factory.bytecode = _bytecode;
TestQuoter__factory.abi = _abi;
